/* Exact-size and exact-finish photography, using only existing catalog photographs. */
(() => {
 if(customElements.get('frond-photo-gallery'))return;
 class FrondPhotoGallery extends HTMLElement {
  connectedCallback(){
   this.data=JSON.parse(this.querySelector('[data-frond-photos]').textContent);
   this.dialog=this.querySelector('dialog');
   this.addEventListener('click',e=>{
    const thumb=e.target.closest('[data-photo-index]');if(thumb)this.show(Number(thumb.dataset.photoIndex));
    if(e.target.closest('.frond-photo-main')){this.dialog.querySelector('img').src=this.photos[this.current].url;this.dialog.querySelector('img').alt=this.photos[this.current].label;this.dialog.showModal();}
    if(e.target.closest('[data-photo-close]'))this.dialog.close();
   });
   this.refresh=()=>{const id=document.querySelector('[data-frond-facts]')?.dataset.variantId||this.dataset.variantId;if(id===this.variant)return;this.variant=id;this.photos=this.data[id]||[];this.render();};
   this.refresh();
   this.observer=new MutationObserver(this.refresh);this.observer.observe(this.closest('product-info'),{childList:true,subtree:true,attributes:true,attributeFilter:['data-variant-id']});
  }
  disconnectedCallback(){this.observer?.disconnect();}
  render(){
   const thumbnails=this.querySelector('.frond-photo-thumbs');thumbnails.replaceChildren();
   this.querySelector('.frond-photo-main').hidden=!this.photos.length;
   if(!this.photos.length){this.querySelector('.frond-photo-caption').textContent='Photography for this finish and size is not yet available. Please contact us for help comparing finishes.';return;}
   this.photos.forEach((photo,i)=>{const button=document.createElement('button');button.type='button';button.dataset.photoIndex=i;button.dataset.ihAction='photo_select';button.dataset.ihResource=photo.key;button.setAttribute('aria-label',photo.label);const img=document.createElement('img');img.src=photo.url;img.alt=photo.label;img.loading='lazy';button.append(img);thumbnails.append(button);});this.show(0);
  }
  show(i){this.current=i;const photo=this.photos[i],img=this.querySelector('.frond-photo-main img');img.src=photo.url;img.alt=photo.label;this.querySelector('.frond-photo-caption').textContent=photo.label+' · Select the photograph to enlarge.';this.querySelectorAll('[data-photo-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.photoIndex)===i)));}
 }
 customElements.define('frond-photo-gallery',FrondPhotoGallery);
})();

/* Match the reviewed Demi/Bold information order without replacing their shared template. */
(() => {
 if(window.frondDraftPlacementInitialized)return;
 window.frondDraftPlacementInitialized=true;
 const arrange=()=>{
  const product=document.querySelector('product-info:has([data-frond-facts])');if(!product||product.hasAttribute('data-catalog-layout'))return;
  const about=product.querySelector('[data-product-about-row]');
  const paired=document.querySelector('[data-paired-products]');
  const pairedSection=paired?.closest('.shopify-section');
  if(about&&pairedSection){
   pairedSection.dataset.frondCoordinate='';
   if(about.previousElementSibling!==pairedSection)about.before(pairedSection);
   const heading=paired.querySelector('h2');if(heading&&heading.textContent!=='Coordinate with Frond')heading.textContent='Coordinate with Frond';
  }
  const heading=product.querySelector('[data-product-support-row] h2');
  if(heading&&heading.textContent!=='Product details')heading.textContent='Product details';
  const faq=document.querySelector('.frond-questions')?.closest('.shopify-section');
  const reviews=document.querySelector('[id$="__1761005796e540868f"]');
  if(faq&&reviews&&faq.parentElement===reviews.parentElement&&reviews.previousElementSibling!==faq)reviews.before(faq);
 };
 let pending=false;
 const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;arrange();});};
 const start=()=>{arrange();const main=document.querySelector('main');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('product-info:loaded',schedule);
})();
